import { render, staticRenderFns } from "./profile-links.vue?vue&type=template&id=2634ca01&"
import script from "./profile-links.vue?vue&type=script&lang=js&"
export * from "./profile-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports